import { useState } from "react";
import { useTranslation } from "react-i18next";
import {
  FooterNavigation,
  Header,
  PaginationHelper,
  TitleBar,
  Dialog,
} from "webapp/components";
import { TDMemberInformationForm } from "webapp/components/Partner/TD/TDMemberInformationForm";
import { AppState } from "webapp/enums/AppState";

export default function TDMemberInformation(props) {
  const { t } = useTranslation();
  const [showFooter, setShowFooter] = useState(true);
  const [showSelectUserModal, setShowSelectUserModal] = useState(false);
  const [selectContact, setSelectContact] = useState(null);
  const [selectAccount, setSelectAccount] = useState(null);

  const LocateUserObj = {
    img: props.logo,
    fragment: (
      <>
        <p className="mb-0">
          <strong>{t("BWC.PolicyInformation.TitleBar1")}</strong>
          <br />
        </p>
      </>
    ),
  };

  const onUserNext = () => {
    const isContactSelected =
      selectContact != null && typeof selectContact === "object";

    const isAccountSelected =
      selectAccount != null && typeof selectAccount === "object";

    if (isContactSelected && isAccountSelected) {
      props.context.setState(
        {
          accountRef: selectAccount.accountRef,
          contactRef: selectContact.contactRef,
          memberRef: selectContact.contactRef,
          webAppState: AppState.ConfirmVehicle,
        },
        () => {
          if (typeof props.onUserNext === "function") {
            props.onUserNext();
          }
          props.context.saveWebAppState(props.context);
        }
      );
    } else {
      /**
       * Notify the user that an unknown error has occurred and to try again
       * set the webAppState to the search page
       */
      setShowSelectUserModal(true);
    }
  };

  const onUserCancel = () => {
    if (typeof props.onUserCancel === "function") {
      props.onUserCancel();
    }
  };
  const onContractLookupComplete = (success) => {
    setShowFooter(!!success);
  };

  const onUserSelectMember = (selectedAccount, selectedContact) => {
    setSelectContact(selectedContact);
    setSelectAccount(selectedAccount);
    // onUserNext(selectAccount, selectContact);
  };

  return (
    <>
      <div className="CustCollectPage">
        <Header
          currState={props.currState}
          onUserBack={props.backButtonFunc}
          information={t("BWC.PolicyInformation.PolicyInformationHeader1")}
        />
        <TitleBar data={LocateUserObj} />
        <PaginationHelper context={props.context} />
        <TDMemberInformationForm
          context={props.context}
          currState={props.currState}
          onUserSelect={onUserSelectMember}
          onUserBack={props.backButtonFunc}
          onUserCancel={onUserCancel}
          onLoad={onContractLookupComplete}
        />
      </div>

      {showFooter ? (
        <FooterNavigation
          onCancelClick={onUserCancel}
          onNextClick={onUserNext}
        />
      ) : (
        <></>
      )}
      {showSelectUserModal && (
        <Dialog
          title={"DriverMissing"}
          message={"ErrorSelectContacts"}
          buttonTitle={"OK"}
          onClose={() => {
            setShowSelectUserModal(false);
          }}
        />
      )}
    </>
  );
}
